import { useMemo } from 'react';
import { TFunction } from 'i18next';
import { splitFormConfig } from './_formConfig';
import {
  createFieldsFromConfig,
  groupFieldsBySection,
  createYupSchemaFromConfig,
} from './_formHelpers';

const useValidationSchema = (t: TFunction, portalSetting: any) => {
  const fields = useMemo(() => createFieldsFromConfig(splitFormConfig, t), [t]);
  const fieldsBySection = useMemo(
    () => groupFieldsBySection(fields, t, portalSetting),
    [fields, portalSetting, t],
  );

  const SplitStudyValidationScheme = useMemo(
    () => createYupSchemaFromConfig(splitFormConfig, t, portalSetting),
    [t, portalSetting],
  );

  return {
    SplitStudyValidationScheme,
    fields: fieldsBySection,
  };
};

export default useValidationSchema;
